import { Component, OnInit } from '@angular/core';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { ReportsTurnsService } from 'src/app/services/turns-services/reports-turns-service/reports-turns.service';
import { DashboardService } from 'src/app/services/dashboard-services/dashboard.service';
import { tap } from 'rxjs/internal/operators/tap';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-dashboard-power',
  templateUrl: './dashboard-power.component.html',
  styleUrls: ['./dashboard-power.component.scss']
})
export class DashboardPowerComponent implements OnInit {

  centers;
  selectedCenters;
  from;
  to;

  powerConsumption;
  noItemsConfig;

  colors = [
    '#3bafda',
    '#ed5565',
    '#fcbb42',
    '#37bc9b',
    '#967adc',
    '#d770ad',
    '#ff9d00',
    '#75560d',
    '#ffe4b5',
    '#eeeeee',
    '#6d7182',
  ];

  dashboardServiceSubscription: Subscription;

  constructor(
    private userStorageService: UserStorageService,
    private reportsTurnsService: ReportsTurnsService,
    private dashboardService: DashboardService,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
      this.centers = this.userStorageService.getCenterList();
      this.noItemsConfig = this.setNoItemsConfig();
    }

  ngOnInit() {
    this.setBreadcrumb();
    this.selectedCenters = [this.centers[0]];
    this.dashboardServiceSubscription = this.dashboardService.listenReloadStatistics().pipe(
      tap(o => this.selectedCenters = o['centers']),
      tap(o => this.from = o['from'].valueOf()),
      tap(o => this.to = o['to'].valueOf()),
      tap(o => this.loadData())
    ).subscribe();
  }

  private loadData() {
    this.getPowerConsumption(this.centers[6], new Date().valueOf(), new Date().valueOf());
  }

  private getPowerConsumption(center, from, to) {
    this.reportsTurnsService.bestDesks(from, to, [center.InternalId]).pipe(
      tap((bestDesks) => {
        this.powerConsumption = (bestDesks as Array<any>).sort((a, b) => a.deskName.toLowerCase() > b.deskName.toLowerCase() ? 1 : -1);
      }),
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th', 'breadcrumb-title.dashboard sales'));
  }

  private setNoItemsConfig() {
    return {
      description: 'dashboard-page.selected centers not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

}
